import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector } from "react-redux";
import Footer from "../../../../components/home_page/Footer";
import { Link } from "react-router-dom";
import { closeModal } from "../../../../redux/actions/action-creator";
import { useDispatch } from "react-redux";
import useClickOutside from "../../../../components/Custom_Hooks/useClickOutsSide";
import NavLayout from "../../../../components/NavNameOfComponent/NavLayout";
import { useDropdownFilter } from "../../../../components/Custom_Hooks/useDropdownFilter";
import { useDropdownKeyboardNavigation } from "../../../../components/Custom_Hooks/useDropdownKeyboardNavigation";
const OtherVoucher = (props) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    search_input: "",
  });
  const { voucher_type_data = null } = useSelector((state) => state.common);

const [voucher_data, setVoucherData] = useState([]);

useEffect(() => {
    if (voucher_type_data) {
        const updatedVoucherData = voucher_type_data.map((item) => {
            const newItem = { ...item };
            if (newItem?.voucher_type_name === "Contra") {
                newItem.shortcut_key = "F4";
            }
            if (newItem?.voucher_type_name === "Payment") {
                newItem.shortcut_key = "F5";
            }
            if (newItem?.voucher_type_name === "Receipt") {
                newItem.shortcut_key = "F6";
            }
            if (newItem?.voucher_type_name === "Journal") {
                newItem.shortcut_key = "F7";
            }
            if (newItem?.voucher_type_name === "Sales") {
                newItem.shortcut_key = "F8";
            }
            if (newItem?.voucher_type_name === "Purchase") {
                newItem.shortcut_key = "F9";
            }
            return newItem;
        });
        setVoucherData(updatedVoucherData);
    }
}, [voucher_type_data]);



  // console.log("this is voucher type :----",voucher_type_data)
  // const [filteredData, setFilteredData] = useState([]);
  const search_input_ref = useRef(null);
  const { search_input } = state;
 
  const handlechange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const { filteredData } = useDropdownFilter({
    dataList: voucher_data,
    searchInput: state.search_input,
    inputRef: search_input_ref,
    isDynamic: false,
  });
  let is_dropdown_clicked = false;
  const { selectedItemIndex, setSelectedItemIndex } =
  
  useDropdownKeyboardNavigation({
    items: filteredData,
    state,
    onItemSelect: (item) => {
      if (item) {
        dispatch(closeModal("otherVoucher"));
        props.displayNameOfVoucherType(
          item?.voucher_type_name,
          voucher_data
        );
      }
    },

    input_value: state.search_input,
  });



  const handleKeyDown = useCallback(
    (e) => {
      // Handle F4-F9 keys for quick voucher type selection
      if (e.key >= "F4" && e.key <= "F9") {
        e.preventDefault();
        const voucherTypeMapping = {
          "F4": "Contra",
          "F5": "Payment", 
          "F6": "Receipt",
          "F7": "Journal",
          "F8": "Sales",
          "F9": "Purchase"
        };
        
        const voucherTypeName = voucherTypeMapping[e.key];
        if (voucherTypeName) {
          // Find the voucher type in the data
          const voucherType = voucher_data?.find(
            item => item?.voucher_type_name === voucherTypeName
          );
          
          if (voucherType) {
            dispatch(closeModal("otherVoucher"));
            props.displayNameOfVoucherType(
              voucherType.voucher_type_name,
              voucher_data
            );
          }
        }
        return;
      }
      if (e.key === "Escape") {
        e.preventDefault();
        dispatch(closeModal("otherVoucher"));
        e.stopPropagation();
      }
    },
    [selectedItemIndex, filteredData, voucher_data]
  );

  const handleClickOutside = (event) => {
    // Prevent losing focus by immediately refocusing the input
    if (search_input_ref?.current) {
      event.preventDefault();
      search_input_ref.current.focus();
    }
  };

  const handleClickInside = (event) => {
    if (search_input_ref?.current) {
      search_input_ref.current.focus();
    }
  };

  // Enhanced focus management
  const maintainFocus = useCallback(() => {
    if (search_input_ref?.current) {
      search_input_ref.current.focus();
    }
  }, []);

  // Focus on mount and maintain focus
  useEffect(() => {
    maintainFocus();
    // Set up interval to maintain focus
    const focusInterval = setInterval(maintainFocus, 100);
    
    // Focus on any mouse or touch event
    const handleMouseDown = () => maintainFocus();
    const handleTouchStart = () => maintainFocus();
    
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('touchstart', handleTouchStart);
    
    return () => {
      clearInterval(focusInterval);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }, [maintainFocus]);

  useClickOutside(search_input_ref, handleClickOutside, handleClickInside);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);


  return (
    <div className="my-card">
      <div
        className="cross_button"
        onClick={() => {
          dispatch(closeModal("otherVoucher"));
          //  props.setshow_other_voucher(false)
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <NavLayout>
        <b className="ps-2">Change Voucher Type </b>
      </NavLayout>
      <div className="container">
        <div class="row justify-content-center">
          <div className="col-12">
            <div className="row justify-content-center">
              <div class="col-4 border bg-light border-dark">
                {/* <p className="p-0 text-center m-0">Change Voucher Type</p> */}
                <input
                  autoFocus
                  className="voucher_entry_account_input"
                  type="text"
                  id="search_input"
                  name="search_input"
                  placeholder="Enter Here......"
                  onChange={handlechange}
                  ref={search_input_ref}
                  value={search_input || ""}
                />
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row justify-content-center">
              <div class="col-4 border bg-light border-dark">
                <div className="row background" style={{ height: 19.5 }}>
                  <div className="col-12 text-left">
                    <div className="row">
                        <div className="col-9 text-start">
                            <p className="text-left">Voucher Type</p>
                        </div>
                        <div className="col-3 text-start ps-0">
                            <p className="text-start">Shortcut Key</p>
                        </div>
                    </div>
                    {/* <p className="text-left"> List of voucher type</p> */}
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-12"
                    style={{ height: "80.3vh", overflowY: "scroll" }}
                  >
                    {filteredData?.length > 0 ? (
                      filteredData?.map((key, number) => {
                        const name = key?.voucher_type_name;
                        const index = name
                          ?.toLowerCase()
                          ?.indexOf(search_input?.toLowerCase());
                        return (
                          <div className="row">
                            <div
                              className={` col-12 dropdown_link ${
                                number === selectedItemIndex ? "selected" : ""
                              }`}
                              key={number}
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedItemIndex(number);
                                if (number === selectedItemIndex) {
                                  setState({ ...state, voucher_name: name });
                                }
                              }}
                            >
                              <Link>
                                <div className="row p-0">
                                  <div className="col-9">
                                    {index !== -1 ? (
                                      <>
                                        {name?.substring(0, index)}
                                        <span style={{ color: "red" }}>
                                          {name?.substring(
                                            index,
                                            index + search_input.length
                                          )}
                                        </span>
                                        {name?.substring(
                                          index + search_input.length
                                        )}
                                      </>
                                    ) : (
                                      name
                                    )}
                                  </div>
                                  <div className="col-3 ps-0">{key?.shortcut_key}</div>
                                </div>
                              </Link>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p style={{ color: "red" }}>No matching items found</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
};
export default OtherVoucher;
